import { IDemo, SessionIds } from 'types'
import track from 'assets/captions/connected-health.en.vtt'
import { getSharedAsset } from '../utils'

const video = getSharedAsset('connected-health.mp4', 'sessions', 'videos')
const poster = getSharedAsset('connected-health.png', 'sessions', 'posters')
const monolith = getSharedAsset('connected-health.png', 'sessions', 'monoliths')
const nextDemoThumbnail = getSharedAsset('managed-venues.png', 'sessions', 'thumbnails')

export const connectedHealth: IDemo = {
  id: SessionIds.connectedHealth,
  video,
  monolith,
  poster,
  tracks: [
    {
      kind: 'captions',
      src: track,
      srcLang: 'en',
      label: 'EN',
      default: false
    }
  ],
  end: {
    header: 'Connected Health',
    body: `Explore the enablement of telemedicine and remote monitoring when paired with 5G-enabled advanced solutions ultra low latency, large data transmission, and Mobile Edge Computing (MEC).`,
    nextDemoText: 'Managed Venues',
    nextDemoId: SessionIds.managedVenues,
    nextDemoThumbnail,
    previousDemoId: SessionIds.videoSecurity
  }
}
